import React, { useContext, useEffect, useState } from 'react';
import { defaultProvider, Provider } from '../../../app/models/Provider';
import useProviderService from '../../../app/services/hooks/useProviderService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';

import useSweetAlert from '../../../hooks/useSweetAlert';
import { Place } from '../../../app/models/Place';
import { Unit } from '../../../app/models/Unit';
import { Currency } from '../../../app/models/Currency';
import {
    RouteSegmentDataForm,
    defaultRouteSegmentDataForm
} from '../../../app/models/RouteSegment';
import useRouteSegmentService from '../../../app/services/hooks/useRouteSegmentService';
import RouteSegmentFormContainer from './RouteSegmentFormContainer';
import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    routeSegmentId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const RouteSegmentEdit = ({ routeSegmentId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        fetchingEditRouteSegment,
        editRouteSegment,
        fetchingUpdateRouteSegment,
        updateRouteSegment
    } = useRouteSegmentService();

    const [origins, setOrigins] = useState<Place[]>([]);
    const [destinations, setDestinations] = useState<Place[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [routeSegment, setRouteSegment] = useState<RouteSegmentDataForm>(
        defaultRouteSegmentDataForm
    );

    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando tramo...');
        editRouteSegment(routeSegmentId, {
            onSuccess: (response: ServiceResponse) => {
                setOrigins(response.data.origins);
                setDestinations(response.data.destinations);
                setUnits(response.data.units);
                setCurrencies(response.data.currencies);

                setRouteSegment(response.data.route_segment);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        // useSweetAlert().spinnerAlert("Actualizando tramo...");
        if (showLoading) showLoading('loading', 'Actualizando tramo...');
        updateRouteSegment(routeSegmentId, routeSegment, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                // useSweetAlert().closeSpinnerAlert();
                // if(changeAnimation)changeAnimation('success','Actualización exitosa', true);
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                // useSweetAlert().closeSpinnerAlert();
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                // useSweetAlert().closeSpinnerAlert();
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditRouteSegment ? (
        <LazyLoading height="300" />
    ) : (
        <RouteSegmentFormContainer
            fetching={fetchingUpdateRouteSegment}
            action={update}
            cancel={cancel}
            routeSegmentForm={routeSegment}
            setRouteSegmentForm={setRouteSegment}
            origins={origins}
            destinations={destinations}
            currencies={currencies}
            units={units}
            errorFields={errorFields}
        />
    );
};

export default RouteSegmentEdit;
